import { FORM_ERROR } from 'final-form';
import { all, call, put, take } from 'redux-saga/effects';
import { push } from 'connected-react-router';

import request from '../../../lib/request';
import { parseFormErrors } from '../../../utils/parseFormErrors';

import { handleSignInSuccess, setAuthToken } from '../../auth/redux';
import { checkForUploadableHintFiles, uploadHintFiles } from '../../upload';

export const QUESTION_SET_REQUEST = 'teacher/question-set/QUESTION_SET_REQUEST';
export const QUESTION_SET_SUCCESS = 'teacher/question-set/QUESTION_SET_SUCCESS';
export const QUESTION_SET_FAILURE = 'teacher/question-set/QUESTION_SET_FAILURE';

export const CREATE_QUESTION_SET_REQUEST = 'teacher/question-set/CREATE_QUESTION_SET_REQUEST';
export const CREATE_QUESTION_SET_SUCCESS = 'teacher/question-set/CREATE_QUESTION_SET_SUCCESS';
export const CREATE_QUESTION_SET_FAILURE = 'teacher/question-set/CREATE_QUESTION_SET_FAILURE';

export const EDIT_QUESTION_SET_REQUEST = 'teacher/question-set/EDIT_QUESTION_SET_REQUEST';
export const EDIT_QUESTION_SET_SUCCESS = 'teacher/question-set/EDIT_QUESTION_SET_SUCCESS';
export const EDIT_QUESTION_SET_FAILURE = 'teacher/question-set/EDIT_QUESTION_SET_FAILURE';

export const DELETE_QUESTION_SET_REQUEST = 'teacher/question-set/DELETE_QUESTION_SET_REQUEST';
export const DELETE_QUESTION_SET_SUCCESS = 'teacher/question-set/DELETE_QUESTION_SET_SUCCESS';
export const DELETE_QUESTION_SET_FAILURE = 'teacher/question-set/DELETE_QUESTION_SET_FAILURE';

export const QUESTION_SET_DASHBOARD_REQUEST = 'teacher/question-set/QUESTION_SET_DASHBOARD_REQUEST';
export const QUESTION_SET_DASHBOARD_SUCCESS = 'teacher/question-set/QUESTION_SET_DASHBOARD_SUCCESS';
export const QUESTION_SET_DASHBOARD_FAILURE = 'teacher/question-set/QUESTION_SET_DASHBOARD_FAILURE';

// Get Question Set by Id
export const handleQuestionSetRequest = (payload) => ({
  type: QUESTION_SET_REQUEST,
  payload
});

export const handleQuestionSetSuccess = (payload) => ({
  type: QUESTION_SET_SUCCESS,
  payload
});

export const handleQuestionSetFailure = (payload) => ({
  type: QUESTION_SET_FAILURE,
  payload
});

// Create New Question Set
export const handleCreateQuestionSetRequest = (payload) => ({
  type: CREATE_QUESTION_SET_REQUEST,
  payload
});

export const handleCreateQuestionSetSuccess = (payload) => ({
  type: CREATE_QUESTION_SET_SUCCESS,
  payload
});

export const handleCreateQuestionSetFailure = (payload) => ({
  type: CREATE_QUESTION_SET_FAILURE,
  payload
});

// Edit Question Set
export const handleEditQuestionSetRequest = (payload) => ({
  type: EDIT_QUESTION_SET_REQUEST,
  payload
});

export const handleEditQuestionSetSuccess = (payload) => ({
  type: EDIT_QUESTION_SET_SUCCESS,
  payload
});

export const handleEditQuestionSetFailure = (payload) => ({
  type: EDIT_QUESTION_SET_FAILURE,
  payload
});

// delete questionset
export const handleDeleteQuestionSetRequest = (payload) => ({
  type: DELETE_QUESTION_SET_REQUEST,
  payload
});

export const handleDeleteQuestionSetSuccess = (payload) => ({
  type: DELETE_QUESTION_SET_SUCCESS,
  payload
});

export const handleDeleteQuestionSetFailure = (payload) => ({
  type: DELETE_QUESTION_SET_FAILURE,
  payload
});

// Question Set Dashboard
export const handleQuestionSetsDashboardRequest = (payload) => ({
  type: QUESTION_SET_DASHBOARD_REQUEST,
  payload
});

export const handleQuestionSetsDashboardSuccess = (payload) => ({
  type: QUESTION_SET_DASHBOARD_SUCCESS,
  payload
});

export const handleQuestionSetsDashboardFailure = (payload) => ({
  type: QUESTION_SET_DASHBOARD_FAILURE,
  payload
});

export function * onHandleQuestionSetsDashboardRequest () {
  console.log('#onHandleQuestionSetsDashboardRequest');

  try {
    console.log('#onHandleQuestionSetsDashboardRequest, try block');
    const response = yield call(request.get, '/question-sets');
    console.log('#onHandleQuestionSetsDashboardRequest, response: ', response);

    const body = response.data;
    const questionSets = Array.isArray(body)
      ? body
      : (body?.questionSets ?? []);
    const { user, token } = body && !Array.isArray(body) ? body : {};

    const sideEffects = [put(handleQuestionSetsDashboardSuccess(questionSets))];
    if (user != null) {
      sideEffects.push(put(handleSignInSuccess(user)));
    }
    if (token != null) {
      sideEffects.push(put(setAuthToken(token)));
    }

    return yield all(sideEffects);
  } catch (err) {
    console.error('Error, #onHandleQuestionSetsDashboardRequest, err: ', err);
    // TODO: Add Notifications to let user know QuestionSetDashboard failed to get loaded and further instructions
    return yield all([put(handleQuestionSetsDashboardFailure(err))]);
  }
}

export function * onHandleQuestionSetRequest ({ payload: questionSetId }) {
  console.log('#onHandleQuestionSetRequest, questionSetId: ', questionSetId);

  try {
    console.log('#onHandleQuestionSetRequest, try block');
    const response = yield call(request.get, `/question-sets/${questionSetId}`);
    console.log('#onHandleQuestionSetRequest, response: ', response);
    const {
      data: { questionSets }
    } = response;
    console.log('#onHandleQuestionSetRequest, questionSets: ', questionSets);

    return yield all([put(handleQuestionSetSuccess(questionSets[0]))]);
  } catch (err) {
    console.error('Error, #onHandleQuestionSetRequest, err: ', err);
  }
}

export function * onHandleCreateQuestionSetRequest ({ payload: reqQuestionSet }) {
  console.log('#onHandleCreateQuestionSetRequest', reqQuestionSet);

  try {
    console.log('#onHandleCreateQuestionSetRequest, try block');
    const response = yield call(request.post, '/question-sets', { questionSet: reqQuestionSet });

    const { data: { questionSet: resQuestionSet } } = response;

    console.log('questionSet: ', resQuestionSet);

    if (checkForUploadableHintFiles(reqQuestionSet)) {
      // we will handle the whole process of adding hint files
      console.log('#onHandleCreateQuestionSetRequest, we have hint files to process');
      console.log('#onHandleCreateQuestionSetRequest, calling uploadHintFiles');
      reqQuestionSet = yield uploadHintFiles(reqQuestionSet);
      // after the hint file is uploaded we update the question set with the files url
      // the reason is we have already created the questionSet so we just need to update the hint urls.
      const updatedQuestionSet = {
        ...resQuestionSet,
        questions: resQuestionSet.questions.map((question, index) => {
          // since the payload question has no id, we use questionStatment for comparison
          if (question.questionStatement === reqQuestionSet.questions[index].questionStatement) {
            return { ...question, hints: reqQuestionSet.questions[index].hints };
          }

          return question;
        })
      };

      // revert it with brandon
      // Create form's MakeAsyncFunction listens for CREATE_SUCCESS / _FAILURE only.
      // Wait for the follow-up edit (hint URLs) so we resolve once the full save is done.
      yield put(handleEditQuestionSetRequest(updatedQuestionSet));
      const editOutcome = yield take([EDIT_QUESTION_SET_SUCCESS, EDIT_QUESTION_SET_FAILURE]);

      if (editOutcome.type === EDIT_QUESTION_SET_FAILURE) {
        return yield put({
          type: CREATE_QUESTION_SET_FAILURE,
          payload: editOutcome.payload
        });
      }

      return yield put(handleCreateQuestionSetSuccess(editOutcome.payload));
    } else {
      // we will save as is because there are no hint files
      console.log('#onHandleCreateQuestionSetRequest, we do not have any hint files to process and can have a single req/res');
      return yield all([
        put(handleCreateQuestionSetSuccess(resQuestionSet)),
        put(push('/teacher/question-sets'))
      ]);
    }
  } catch (err) {
    console.error('Error, #onHandleCreateQuestionSetRequest, err: ', err);
    if (!err.response || !err.response.data) {
      return yield put({
        type: CREATE_QUESTION_SET_FAILURE,
        payload: {
          [FORM_ERROR]: err.message || 'Something went wrong while saving. Please try again.'
        }
      });
    }
    const { status, message, errors } = err.response.data;

    if (message === 'Network Error') {
      return yield put({
        type: CREATE_QUESTION_SET_FAILURE,
        payload: { [FORM_ERROR]: 'Network Error? Check your connection and please try again later...' }
      });
    }

    if (status === 409) {
      return yield put({
        type: CREATE_QUESTION_SET_SUCCESS,
        payload: {
          [FORM_ERROR]: message,
          ...parseFormErrors(errors)
        }
      });
    }

    if (status === 422 || status === 400) {
      return yield put({
        type: CREATE_QUESTION_SET_SUCCESS,
        payload: {
          [FORM_ERROR]: message,
          ...parseFormErrors(errors)
        }
      });
    }

    if (err.response.status === 500) {
      return yield put({
        type: CREATE_QUESTION_SET_FAILURE,
        payload: { [FORM_ERROR]: 'Its not you, its us....... Please try again later.' }
      });
    }

    return yield put({
      type: CREATE_QUESTION_SET_FAILURE,
      payload: {
        [FORM_ERROR]:
          message ||
          err.response?.statusText ||
          `Request failed (${err.response.status}). Please try again.`
      }
    });
  }
}

export function * onHandleEditQuestionSetRequest ({ payload }) {
  console.log('onHandleEditQuestionSetRequest, payload: ', payload);

  try {
    console.log('#onHandleEditQuestionSetRequest, try block');

    // checking if there is a new file and uploading the file if there is a new file
    // otherwise it will just check and skip
    payload = yield uploadHintFiles(payload);

    const response = yield call(request.put, `/question-sets/${payload.id}`, {
      questionSet: payload
    });

    console.log('#onHandleEditQuestionSetRequest, response: ', response);
    const {
      data: { questionSet }
    } = response;
    console.log('questionSet: ', questionSet);
    return yield all([
      put(handleEditQuestionSetSuccess(questionSet)),
      put(push('/teacher/question-sets'))
    ]);
  } catch (err) {
    console.error('Error, #onHandleEditQuestionSetRequest, err: ', err);

    if (!err.response || !err.response.data) {
      return yield put({
        type: EDIT_QUESTION_SET_FAILURE,
        payload: {
          [FORM_ERROR]: err.message || 'Something went wrong while saving. Please try again.'
        }
      });
    }

    const { status, message, errors } = err.response.data;
    if (message === 'Network Error') {
      return yield put({
        type: EDIT_QUESTION_SET_FAILURE,
        payload: {
          [FORM_ERROR]:
            'Network Error? Check your connection and please try again later...'
        }
      });
    }

    if (status === 409) {
      return yield put({
        type: EDIT_QUESTION_SET_FAILURE,
        payload: {
          [FORM_ERROR]: 'Already exists...',
          ...parseFormErrors(errors)
        }
      });
    }

    if (status === 422 || status === 400) {
      return yield put({
        type: EDIT_QUESTION_SET_FAILURE,
        payload: {
          [FORM_ERROR]: message,
          ...parseFormErrors(errors)
        }
      });
    }

    if (err.response.status === 500) {
      return yield put({
        type: EDIT_QUESTION_SET_FAILURE,
        payload: {
          [FORM_ERROR]: 'Its not you, its us....... Please try again later.'
        }
      });
    }

    return yield put({
      type: EDIT_QUESTION_SET_FAILURE,
      payload: {
        [FORM_ERROR]:
          message ||
          err.response?.statusText ||
          `Request failed (${err.response.status}). Please try again.`
      }
    });
  }
}

export function * onHandleDeleteQuestionSetRequest ({ payload }) {
  console.log('onHandleDeleteQuestionSetRequest, payload: ', payload);

  try {
    console.log('#onHandleDeleteQuestionSetRequest, try block');

    const response = yield call(request.del, `/question-sets/${payload}`);
    console.log('#onHandleDeleteQuestionSetRequest, response: ', response);

    return yield all([
      put(handleDeleteQuestionSetSuccess(payload)),
      put(push('/teacher/question-sets'))
    ]);
  } catch (err) {
    console.error('Error, #onHandleDeleteQuestionSetRequest, err: ', err);

    const { message } = err.response.data;
    if (message === 'Network Error') {
      return yield put({
        type: DELETE_QUESTION_SET_FAILURE,
        payload: {
          [FORM_ERROR]:
            'Network Error? Check your connection and please try again later...'
        }
      });
    }

    if (err.response.status === 500) {
      return yield put({
        type: DELETE_QUESTION_SET_FAILURE,
        payload: {
          [FORM_ERROR]: 'Its not you, its us....... Please try again later.'
        }
      });
    }
  }
}

export const FETCH_GENERATED_QUESTION_SET_REQUEST = 'teacher/question-set/FETCH_GENERATED_QUESTION_SET_REQUEST';
export const FETCH_GENERATED_QUESTION_SET_SUCCESS = 'teacher/question-set/FETCH_GENERATED_QUESTION_SET_SUCCESS';
export const FETCH_GENERATED_QUESTION_SET_FAILURE = 'teacher/question-set/FETCH_GENERATED_QUESTION_SET_FAILURE';
export const CLEAR_GENERATED_QUESTION_SET = 'teacher/question-set/CLEAR_GENERATED_QUESTION_SET';

// Get Generated Question Set
export const handleFetchGeneratedQuestionSetRequest = (payload) => ({
  type: FETCH_GENERATED_QUESTION_SET_REQUEST,
  payload
});

export const handleClearGeneratedQuestionSet = () => ({
  type: CLEAR_GENERATED_QUESTION_SET
});

export const handleFetchGeneratedQuestionSetSuccess = (payload) => ({
  type: FETCH_GENERATED_QUESTION_SET_SUCCESS,
  payload
});

export const handleFetchGeneratedQuestionSetFailure = (payload) => ({
  type: FETCH_GENERATED_QUESTION_SET_FAILURE,
  payload
});

export function * onHandleFetchGeneratedQuestionSetRequest ({ payload } = {}) {
  console.log('onHandleFetchGeneratedQuestionSetRequest, payload: ', payload);
  try {
    const body = { prompt: payload.prompt };
    if (payload.model) {
      body.model = payload.model;
    }
    const res = yield call(request.post, 'gemini/questions/structured', body);
    return yield put(handleFetchGeneratedQuestionSetSuccess(res.data));
  } catch (err) {
    const message =
      err?.response?.data?.message ||
      err?.message ||
      'Could not generate questions.';
    return yield put(handleFetchGeneratedQuestionSetFailure(message));
  }
}

const INITIAL_STATE = {
  isLoading: false,
  data: [],
  error: null,
  isGenerating: false,
  generatedQuestionSet: null,
  generatedQuestionSetError: null
};

export default function questionSets (state = INITIAL_STATE, action) {
  switch (action.type) {
    case EDIT_QUESTION_SET_REQUEST:
    case CREATE_QUESTION_SET_REQUEST:
    case QUESTION_SET_DASHBOARD_REQUEST:
    case DELETE_QUESTION_SET_REQUEST:
      return { ...state, isLoading: true };
    case CREATE_QUESTION_SET_SUCCESS: {
      const created = action.payload;
      const existingData = Array.isArray(state.data) ? state.data : [];
      // Only merge when the payload actually looks like a saved question set
      // (the saga also dispatches this action with a FORM_ERROR payload on 409/422/400).
      const isSavedDoc = created && created.id && created.title;
      const nextData = isSavedDoc
        ? (existingData.some(qs => qs?.id === created.id)
          ? existingData.map(qs => (qs?.id === created.id ? { ...qs, ...created } : qs))
          : [created, ...existingData])
        : existingData;
      return {
        ...state,
        isLoading: false,
        questionSet: created,
        data: nextData
      };
    }
    case EDIT_QUESTION_SET_SUCCESS: {
      const edited = action.payload;
      const existingData = Array.isArray(state.data) ? state.data : [];
      const nextData = (edited && edited.id)
        ? (existingData.some(qs => qs?.id === edited.id)
          ? existingData.map(qs => (qs?.id === edited.id ? { ...qs, ...edited } : qs))
          : [edited, ...existingData])
        : existingData;
      return {
        ...state,
        isLoading: false,
        questionSet: edited,
        data: nextData
      };
    }
    case QUESTION_SET_SUCCESS:
      return {
        ...state,
        isLoading: false,
        questionSet: action.payload
      };
    case DELETE_QUESTION_SET_SUCCESS: {
      const deletedId = action.payload;
      const existingData = Array.isArray(state.data) ? state.data : [];
      const nextData = deletedId
        ? existingData.filter(qs => qs?.id !== deletedId)
        : existingData;
      return {
        ...state,
        isLoading: false,
        data: nextData
      };
    }
    case DELETE_QUESTION_SET_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload
      };
    case QUESTION_SET_DASHBOARD_SUCCESS:
      return {
        ...state,
        isLoading: false,
        data: action.payload
      };
    case EDIT_QUESTION_SET_FAILURE:
    case CREATE_QUESTION_SET_FAILURE:
    case QUESTION_SET_DASHBOARD_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload
      };
    case FETCH_GENERATED_QUESTION_SET_REQUEST:
      return {
        ...state,
        isGenerating: true,
        generatedQuestionSet: null,
        generatedQuestionSetError: null
      };
    case FETCH_GENERATED_QUESTION_SET_SUCCESS:
      return {
        ...state,
        isGenerating: false,
        generatedQuestionSet: action.payload
      };
    case FETCH_GENERATED_QUESTION_SET_FAILURE:
      return {
        ...state,
        isGenerating: false,
        generatedQuestionSetError: action.payload
      };
    case CLEAR_GENERATED_QUESTION_SET:
      return {
        ...state,
        isGenerating: false,
        generatedQuestionSet: null,
        generatedQuestionSetError: null
      };
    default:
      return state;
  }
}
